// Centralized data-testid constants
export const NAV = {
  logo: 'nav-logo',
  searchInput: 'nav-search-input',
  cartButton: 'nav-cart-button',
  cartBadge: 'nav-cart-badge',
  mobileHome: 'mobile-nav-home',
  mobileCategories: 'mobile-nav-shop',
  mobileTrack: 'mobile-nav-track',
  mobileCart: 'mobile-nav-cart',
  whatsappButton: 'whatsapp-fab',
};

export const HOME = {
  emergentLink: 'emergent-link',
  heroSection: 'hero-section',
  featuredSection: 'featured-section',
  categoriesSection: 'categories-section',
};

export const HERO = {
  shopNowBtn: 'hero-shop-now-btn',
  exploreCategoriesBtn: 'hero-explore-categories-btn',
};

export const PRODUCT = {
  card: (id) => `product-card-${id}`,
  title: (id) => `product-title-${id}`,
  addBtn: (id) => `product-add-btn-${id}`,
  incBtn: (id) => `product-inc-btn-${id}`,
  decBtn: (id) => `product-dec-btn-${id}`,
  qty: (id) => `product-qty-${id}`,
  detailAddBtn: 'product-detail-add-btn',
};

export const CATEGORY = {
  card: (slug) => `category-card-${slug}`,
};

export const CART = {
  drawer: 'cart-drawer',
  empty: 'cart-empty',
  startShoppingButton: 'cart-start-shopping-btn',
  itemsList: 'cart-items-list',
  item: 'cart-item',
  increment: 'cart-inc',
  decrement: 'cart-dec',
  remove: 'cart-remove',
  quantity: 'cart-qty',
  subtotal: 'cart-subtotal',
  deliveryCharge: 'cart-delivery-charge',
  total: 'cart-total',
  minOrderWarning: 'cart-min-order-warning',
  freeDeliveryProgress: 'cart-free-delivery-progress',
  checkoutButton: 'cart-checkout-btn',
};

export const CHECKOUT = {
  form: 'checkout-form',
  name: 'checkout-name',
  phone: 'checkout-phone',
  email: 'checkout-email',
  line1: 'checkout-line1',
  line2: 'checkout-line2',
  city: 'checkout-city',
  state: 'checkout-state',
  pincode: 'checkout-pincode',
  landmark: 'checkout-landmark',
  notes: 'checkout-notes',
  placeOrderBtn: 'checkout-place-order-btn',
  successOrderNo: 'checkout-success-order-no',
};

export const TRACK = {
  input: 'track-input',
  btn: 'track-btn',
  resultCard: 'track-result-card',
  cancelBtn: 'track-cancel-btn',
  cancelReasonSelect: 'track-cancel-reason-select',
  cancelConfirmBtn: 'track-cancel-confirm-btn',
  cancelModalClose: 'track-cancel-modal-close',
  cancelledBanner: 'track-cancelled-banner',
  revisedBanner: 'track-revised-banner',
  discountLine: 'track-discount-line',
  historyBtn: 'track-history-btn',
  historyPhone: 'track-history-phone',
  historyLastOrder: 'track-history-last-order',
  historyFetchBtn: 'track-history-fetch-btn',
  historyList: 'track-history-list',
  historyItem: (no) => `track-history-item-${no}`,
};

export const ADMIN = {
  loginEmail: 'admin-login-email',
  loginPassword: 'admin-login-password',
  loginBtn: 'admin-login-btn',
  navDashboard: 'admin-nav-dashboard',
  navProducts: 'admin-nav-products',
  navCategories: 'admin-nav-categories',
  navOrders: 'admin-nav-orders',
  navCustomers: 'admin-nav-customers',
  navSettings: 'admin-nav-settings',
  logoutBtn: 'admin-logout-btn',
  // Products
  addProductBtn: 'admin-add-product-btn',
  productName: 'admin-product-name',
  productCategory: 'admin-product-category',
  productPrice: 'admin-product-price',
  productMrp: 'admin-product-mrp',
  productUnit: 'admin-product-unit',
  productImage: 'admin-product-image',
  productDescription: 'admin-product-description',
  productActive: 'admin-product-active',
  productFeatured: 'admin-product-featured',
  productSaveBtn: 'admin-product-save-btn',
  productCancelBtn: 'admin-product-cancel-btn',
  productEditBtn: (id) => `admin-product-edit-${id}`,
  productDeleteBtn: (id) => `admin-product-delete-${id}`,
  // Categories
  addCategoryBtn: 'admin-add-category-btn',
  categoryName: 'admin-category-name',
  categoryDescription: 'admin-category-description',
  categoryImage: 'admin-category-image',
  categorySaveBtn: 'admin-category-save-btn',
  categoryEditBtn: (id) => `admin-category-edit-${id}`,
  categoryDeleteBtn: (id) => `admin-category-delete-${id}`,
  // Settings
  settingsDeliveryCharge: 'admin-settings-delivery-charge',
  settingsMinOrderValue: 'admin-settings-min-order',
  settingsFreeDeliveryAbove: 'admin-settings-free-delivery',
  settingsWhatsapp: 'admin-settings-whatsapp',
  settingsStorePhone: 'admin-settings-phone',
  settingsSaveBtn: 'admin-settings-save-btn',
  // Orders
  orderStatusSelect: (id) => `admin-order-status-${id}`,
  orderReviseBtn: (id) => `admin-order-revise-${id}`,
  orderReviseModal: 'admin-order-revise-modal',
  orderReviseQtyInput: (pid) => `admin-order-revise-qty-${pid}`,
  orderReviseDiscount: 'admin-order-revise-discount',
  orderReviseNote: 'admin-order-revise-note',
  orderReviseSaveBtn: 'admin-order-revise-save-btn',
  orderReviseCancelBtn: 'admin-order-revise-cancel-btn',
  orderRevisedBadge: (id) => `admin-order-revised-badge-${id}`,
  // Stock toggle
  productStockToggle: (id) => `admin-product-stock-toggle-${id}`,
  // Dashboard granular
  dashCardToday: 'admin-dash-card-today',
  dashCardCancelled: 'admin-dash-card-cancelled',
  dashCardPacked: 'admin-dash-card-packed',
  dashCardOfd: 'admin-dash-card-out-for-delivery',
  dashCardTodayRevenue: 'admin-dash-card-today-revenue',
};

export const INVOICE = {
  actions: 'invoice-actions',
  printBtn: 'invoice-print-btn',
  shareBtn: 'invoice-share-btn',
  whatsappBtn: 'invoice-whatsapp-btn',
};
